module.exports = "#legal {\n  background-color: #fff;\n  height: 100%;\n}\n#tos-container {\n  padding: 20px;\n}\n#tos-container h2 {\n  color: #ea148c;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/legals/legals.component.less
// module id = 512
// module chunks = 0